module.exports = __webpack_public_path__ + "img/filters.d6cfbdf5.svg";